import React from "react";

const LoadingSkeleton = () => {
  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 animate-pulse">
      {/* Category tabs skeleton */}
      <div className="flex space-x-4 mb-8 overflow-x-auto">
        {[1, 2, 3, 4].map((item) => (
          <div
            key={item}
            className="h-10 w-32 bg-slate-200 rounded-md"
          ></div>
        ))}
      </div>

      {/* Category title and description skeleton */}
      <div className="mb-8">
        <div className="h-8 w-64 bg-slate-200 rounded-md mb-4"></div>
        <div className="h-4 w-full max-w-2xl bg-slate-200 rounded-md"></div>
      </div>

      {/* Technology grid skeleton */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
        {Array.from({ length: 12 }).map((_, index) => (
          <div
            key={index}
            className="flex flex-col items-center p-4 rounded-lg border border-slate-200 bg-white"
          >
            <div className="w-16 h-16 bg-slate-200 rounded-md mb-4"></div>
            <div className="h-4 w-20 bg-slate-200 rounded-md"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingSkeleton;